import { registerModule } from '@argon/app/helpers'
import routes from './router'
import store, { NAMESPACE } from './store'

const navItems = {
  organizations: [
    {
      name: 'clients',
      weight: 51,
      component: () => import('./components/ClientsNavItem')
    }
  ]
}

const VuePlugin = {
  install: (Vue, options) => {
    registerModule(options.router, options.store, options.i18n, {
      namespace: NAMESPACE,
      routes: routes,
      namespaceStore: store,
      navItems: navItems
    })
  }
}

export default VuePlugin
